export const BUILD_INFO_CONST = {
  time: '2026-11-05T11:24:46.330Z',
  commit: 'f0872eab',
  branch: 'develop',
  tag: 'unknown',
};
